import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../components/more.vue'
import mainBox from "../components/main.vue";
import baseInfo from "../components/Menu/baseInfo.vue";
import repair from "../components/Menu/repair.vue";
import starand from "../components/Menu/starand.vue";
import public_ from "../components/Menu/public_.vue";
import wxzj from "../components/Menu/wxzj.vue";
import decoration from "../components/Menu/decoration.vue";
import safe from "../components/Menu/safe.vue";

import credit from "../components/Menu/credit.vue";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'mainBox',
        component: mainBox
    },
    {
        path: '/baseInfo',
        name: 'baseInfo',
        component: baseInfo
    },


    {
        path: '/info',
        name: 'info',
        component: HomeView
    },
    {
        path: '/repair',
        name: 'repair',
        component: repair
    },
    {
        path: '/starand',
        name: 'starand',
        component: starand
    },
    {
        path: '/public',
        name: 'public',
        component: public_
    }, {
        path: '/wxzj',
        name: 'wxzj',
        component: wxzj
    }, {
        path: '/safe',
        name: 'safe',
        component: safe
    }, {
        path: '/decoration',
        name: 'decoration',
        component: decoration
    }, {
        path: '/credit',
        name: 'credit',
        component: credit
    },

]

const router = new VueRouter({
    mode: "history",
    routes
})

export default router
